import { IManifest, CoreManifest } from '../manifest';

import { IEndpoint } from './types';

/*
 * # Resolve Endpoint
 *
 * A function that resolves the endpoint version from the manifest and returns the endpoint object.
 * */
export const resolveEndpoint = <PossibleVersions extends string, ReturnValue, Options>(
  endpoint: keyof IManifest['endpoints'],
  endpoints: Record<PossibleVersions, IEndpoint<ReturnValue, Options>>
): IEndpoint<ReturnValue, Options> => {
  const version = CoreManifest.endpoints[endpoint] as PossibleVersions;
  if (!endpoints[version]) {
    throw new Error(`This version of core does not support the endpoint ${endpoint} version ${version}`);
  }
  return endpoints[version];
};
